import React, { useCallback, useMemo } from "react";
import { useSearchParams } from "react-router-dom";
import BookingsPage from "./BookingsPage";
import { parseBookingFocus } from "./bookingFocus";

/**
 * The `/bookings` route: `BookingsPage`, plus the booking the URL asks it to
 * open (`?bookingId=…`, which is where a chat event card's **View booking**
 * lands).
 *
 * A wrapper rather than a hook inside `BookingsPage` so the page itself stays
 * free of the router and keeps rendering in tests, and anywhere else, without
 * one.
 *
 * Once the page has acted on the focus the query string is dropped — replaced,
 * not pushed — so a refresh or Back does not reopen the same drawer.
 */
export default function BookingsRoute() {
  const [searchParams, setSearchParams] = useSearchParams();
  const key = searchParams.toString();
  // Keyed on the string, not the object: `searchParams` is a new instance on
  // every render, and a new focus object each time would re-trigger the open.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const focus = useMemo(() => parseBookingFocus(searchParams), [key]);

  const clearFocus = useCallback(() => {
    setSearchParams({}, { replace: true });
  }, [setSearchParams]);

  return <BookingsPage focus={focus} onFocusHandled={clearFocus} />;
}
